import { css } from '@emotion/react'

export const buttons = css`
  display: flex;
  flex-direction: column;
  gap: 10px;

  div {
    width: 100%;
    display: flex;
    gap: 16px;
  }
`
